import { MenuItem } from "@mui/material"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown } from "../../../../../../shared/components/forms/Formik"
import { CompanyIdCardsQuery, fetchUserGroupsForCompany } from "../importUsersApi"
import { ImportUsersFormValues, UserGroup } from "../importUsersTypes"
import { useCurrentCompany } from "../../../../hooks/useCurrentCompany"
import { useApiQuery } from "../../../../../../core/api/useApiQuery"

type SelectUserGroupDropdownProps = Readonly<{}>

export function SelectUserGroupDropdown({}: SelectUserGroupDropdownProps) {
    const { companyId } = useCurrentCompany()

    const { data: userGroups = [] } = useApiQuery(fetchUserGroupsForCompany, {
        queryName: CompanyIdCardsQuery.USER_GROUPS_FOR_COMPANY,
        dependencies: {
            companyId,
        },
        select: (data) => data.userGroups,
    })

    return (
        <LocalizedStrict id="create-or-edit-company-id-cards-field-user-group" attrs={{ label: true }}>
            <FormikDropdown<ImportUsersFormValues> fullWidth name="userGroupId" label="User group">
                <MenuItem value={UserGroup.FROM_FILE}>
                    <LocalizedStrict id="company-data-import-users-select-item-from-file">
                        <span>From file</span>
                    </LocalizedStrict>
                </MenuItem>
                {userGroups.map((userGroup) => (
                    <MenuItem key={userGroup.id} value={userGroup.id}>
                        {userGroup.name}
                    </MenuItem>
                ))}
            </FormikDropdown>
        </LocalizedStrict>
    )
}
